import React from 'react';
import { NavLink } from 'react-router-dom';
import { MdHome, MdRestaurant, MdBedtime, MdBabyChangingStation, MdMoreHoriz } from '../icons';
import { FOCUS_RING, cx } from './toneStyles';

const navItems = [
  { to: '/', icon: MdHome, label: 'Home' },
  { to: '/feed', icon: MdRestaurant, label: 'Feed' },
  { to: '/sleep', icon: MdBedtime, label: 'Sleep' },
  { to: '/nappy', icon: MdBabyChangingStation, label: 'Nappy' },
  { to: '/more', icon: MdMoreHoriz, label: 'More' },
];

export default function BottomNav() {
  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-30 bg-white dark:bg-night-surface border-t border-surface-200 dark:border-night-border safe-area-bottom">
      <div className="flex items-stretch justify-around h-16">
        {navItems.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cx(
                'flex flex-col items-center justify-center gap-0.5 px-3 min-w-[64px] min-h-[44px]',
                'transition-colors duration-fast ease-out',
                FOCUS_RING,
                'focus-visible:ring-inset focus-visible:ring-offset-0',
                isActive
                  ? 'text-primary-600 dark:text-primary-400'
                  : 'text-ink-faint dark:text-night-muted'
              )
            }
          >
            <item.icon className="w-6 h-6" aria-hidden="true" />
            <span className="text-xs font-medium">{item.label}</span>
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
